angular.module('tf.services')

    .service('RecaptchaService', function () {
        var recaptchaV3Key = '6LexbtMUAAAAAFqkYTZSyf32EuvKLtML1hmus-9A';

        var renderRecaptcha = function(elementId, cb){
            var recaptchaKey = '6LcK0w8UAAAAAPUV6TX-Mc4USc96isIqsk84JcdT';
            grecaptcha.render(elementId, {
                'sitekey' : recaptchaKey,
                'callback' : cb
            });
        };

        function attemptRenderRecaptcha(elementId, cb){
            var retries = 0;
            var maxRetries = 5;
            var interval = setInterval(function(){
                if(window.recaptchaLoaded){
                    renderRecaptcha(elementId, cb);
                    clearInterval(interval);
                } else {
                    retries++;
                    if(retries >= maxRetries){
                        clearInterval(interval);
                    }
                }
            }, 1000);
        }

        this.render = function(elementId, cb) {
            attemptRenderRecaptcha(elementId,  function () {
                    cb();
                    grecaptcha.reset();
            });
        };

        this.renderV3 = function(elementId){
            if(grecaptcha && grecaptcha.render){
                grecaptcha.render(elementId, {'sitekey' : recaptchaV3Key, 'size':'invisible'});
            }else{
                grecaptcha.ready(function(){
                    grecaptcha.render(elementId, {'sitekey' : recaptchaV3Key, 'size':'invisible'});
                });
            }
        };
        this.execute = function(action){
            grecaptcha.reset();
            return grecaptcha.execute(recaptchaV3Key, {action: action});
        };
        this.reset = function(){
            return grecaptcha.reset();
        };

        return this;
    })
;
